import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { Snowplow2StatsSchemaBrokerContextInterface } from '../schema/broker-context.interface';
import { StatsDataBrokerInterface } from '../../../stats/data/broker.interface';

export class Snowplow2StatsAdapterSchemaBrokerContext implements StatsAdapterInterface {
  /**
   *
   * @param rawData
   * @param context
   */
  constructor(protected rawData: StatsDataBrokerInterface, protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): Snowplow2StatsSchemaBrokerContextInterface {
    const schema: Snowplow2StatsSchemaBrokerContextInterface = {
      schema: 'iglu:ae.propertyfinder/broker_context/jsonschema/1-0-0',
      data: {
        id: this.rawData.id,
        name: this.rawData.name,
      },
    };

    return schema;
  }
}
